module.exports = __webpack_public_path__ + "img/station-icon_1.111d6ee5.png";